import React from 'react';

export default function RadioYesOrNo({ question, onChange, value }) {

    return (
        <div className='yes-no-radio' role="radiogroup" aria-labelledby='yes-no-radio-id'>
            <label id='yes-no-radio-id'>{question}</label>
            <div className='radio-section'>
                <div
                    tabIndex={0}
                    role='radio'
                    aria-checked={value === true}
                    onClick={() => onChange(true)}
                    className={value === true ? 'radio active' : 'radio'}
                    aria-labelledby='yes'
                    id='yes-radio'
                >
                    <div className='round'></div>
                    <label id="yes" className='text'>Yes</label>
                </div>
                <div
                    tabIndex={0}
                    role='radio'
                    aria-checked={value === false}
                    onClick={() => onChange(false)}
                    className={value === false ? 'radio active' : 'radio'}
                    aria-labelledby='no'
                    id='no-radio'
                >
                    <div className='round'></div>
                    <label id="no" className='text'>No</label>
                </div>
            </div>
        </div>
    );
}
